import { IFoldersList } from 'interfaces/folders.interface';

const getFolderUrl = (folder: IFoldersList) => {
  if (!folder.path) return '/templates';
  return folder.path.reduce((acc, { translatedName }) => `${acc}/${translatedName}`, '/templates') + '/' + folder.translatedName;
};

export default getFolderUrl;
